import React, { useEffect, useRef, useState } from 'react'

import getHatchProfile from "@/services/ProductService/getHatchProfiles"
import Modal from '@/components/Modal/Modal'
import HatchProfileForm from '@/components/HatchProfile/HatchProfileForm'
import { ProfileFilter } from '@/types/hatchProfile'


import { closeNotif, startNotif } from '@/components/DynamicForm/util/notifier'
import deletePricing from '@/services/PricingServices/deletePricing'

import SearchBar from '@/components/UiElements/SearchBar'
import Splash from '@/components/splash/Splash'
import Pagination from '@/components/UiElements/Pagination'
import HatchProfileItems from '@/components/HatchProfile/HatchProfileItems'


import {HatchProfileFormData} from '@/types/hatchProfile'

const perPage = 20


export default function HatchProfilePage() {


	const paginationRef = useRef<any>(null)
	const [profiles, setProfiles] = useState<Array<any>>([])
	const [filteredProfiles, setFilteredProfiles] = useState<Array<any>>([])
	const [total, setTotal] = React.useState<number>(0)
	const [loading, setLoading] = React.useState<boolean>(true)

	const [selectedProfile, setSelectedProfile] = useState<any>(null)
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

	const [filter, setFilter] = useState<ProfileFilter>({
		text: '',
	})




	const handleGetPageData = (pageNumber: number) => {
		const start = (pageNumber - 1) * perPage
		const end = start + perPage
		return filteredProfiles.slice(start, end)
	}

	const handleGetProfileList = async () => {
		const list: HatchProfileFormData[] = await getHatchProfile(1) || []
		setTotal(Math.ceil(list.length / perPage))
		setProfiles(list)
		setLoading(false)
	}

	const handleOpenModal = (item: any) => {
		setIsModalOpen(true)
		setSelectedProfile(item)
	}




	/*const handleChangeFilter = (item: any) => {
		setFilter(currentFilter => {
			const updatedFilter = { ...currentFilter }
			/!*switch (item.price_model) {
				case 'fixed':
					updatedFilter.fixed = item.enabled
					break
				case 'section':
					updatedFilter.section = item.enabled
					break
				case 'element':
					updatedFilter.element = item.enabled
					break
				case 'size':
					updatedFilter.size = item.enabled
					break
				default:
					break
			}*!/
			return updatedFilter
		})
	}*/
	const handleCloseModal = () => {
		setIsModalOpen(false)
		setSelectedProfile(null)
	}


	const handleOnUpdateSuccess = () => {
		handleGetProfileList()
		handleCloseModal()
		/*const mappedData = mapSavedDataToList(data)
		if (mappedData.new) {

			const newList = [mappedData, ...profiles]
			setProfiles(newList)
		} else {

			const updatedList = profiles.map((item: any) => item.id === mappedData.id ? mappedData : item);
			setProfiles(updatedList)
		}*/
	}



	const handleAddNewProfile = () => {
		setIsModalOpen(true)
		setSelectedProfile(null)
	}


	const handleDeleteModel = async (id: string) => {
		const toast = startNotif('Deleting Hatch profile...')

		const delRes = await deletePricing(id)
		if (delRes) {
			closeNotif(toast, 'Hatch profile deleted successfully.')
			const updatedList = profiles.filter((item: any) => item.id !== id);
			setProfiles(updatedList)
		} else{
			closeNotif(toast, 'Failed to delete Hatch profile.', {
				type: 'error'
			})
		}


	}




	useEffect(() => {
		handleGetProfileList()
	}, [])



	useEffect(() => {

		const newList = profiles.filter((profile) => {
			const string = `${profile.name.toLowerCase()}`
			const text = filter.text.toLowerCase()
			return string.includes(text)
		})/*.filter((price) => {
			return filter.section && price.price_model?.value?.toLowerCase() === 'section' ||
				filter.fixed && price.price_model?.value?.toLowerCase() === 'fixed' ||
				filter.element && price.price_model?.value?.toLowerCase() === 'element' ||
				filter.size && price.price_model?.value?.toLowerCase() === 'size';

		})*/

		setFilteredProfiles(newList)
		paginationRef.current?.reset()
		setTotal(Math.ceil(newList.length / perPage))
	}, [filter, profiles])











	return (
		<div className={'min-h-[100%] relative'}>
			<Modal isOpen={isModalOpen} onClose={() => handleCloseModal()} title={selectedProfile ? selectedProfile.id === "duplicate" ? "Duplicate Hatch profile" : "Edit Hatch profile" : "Add Hatch profile"} closeOnOutsideClick={false}>
				<HatchProfileForm profile={selectedProfile} onUpdateSuccess={handleOnUpdateSuccess} onCancel={handleCloseModal}/>
			</Modal>
			<div className={'sticky top-[48px] bg-white z-[10]'}>
				<div className={'h-[48px] absolute top-[-48px] w-full bg-white z-[-1]'}></div>
				<SearchBar
					placeholder={'Search by hatch profile name'}
					searchText={filter.text}
					onChange={(text) => setFilter(prev => ({ ...prev, text }))}
					options={[
						{
							label: (
								<span className="flex flex-row gap-md">
									<span className="font-icon-solid text-primary">+</span>
									New Profile
								</span>
							),
							onClick: handleAddNewProfile
						}
					]}
				/>
			</div>
			{loading && <Splash />}
			{(filteredProfiles.length > 0 && total > 0) ?
				<Pagination
					ref={paginationRef}
					theme={(data) => {
						return (
							<HatchProfileItems profile={data} callBack={handleOpenModal} onDelete={handleDeleteModel}/>
						)
					}}
					total={total}
					offset={150}
					getPageData={handleGetPageData}
					className={'pt-xxl'}
				/>
				:
				<div className={'flex flex-row justify-center items-center px-mx py-xl text-gray-300 bg-gray-50 rounded-md mt-xxl gap-lg h-[150px]'}>
					<p>
						<span>No results match your current filters. Try </span>
						<span
							className={'text-gray-300 underline cursor-pointer hover:text-gray-900 transition-all'}
							onClick={() => setFilter({ text: '' })}
						>
							resetting some filters
						</span>
						<span> to see more options.</span>
					</p>
				</div>
			}
		</div>
	)
}
